/** Extract email probe rows from stored admin SSE events. */

/**
 * @param {unknown} search
 * @returns {Array<Record<string, unknown>>}
 */
export function extractEmailProbeRowsFromSearch(search) {
  const events = search?.result_json?.events;
  if (!Array.isArray(events)) return [];

  const rows = [];
  for (const ev of events) {
    if (!ev || typeof ev !== 'object') continue;
    const bucket = String(ev.ui_bucket || '').trim();
    if (bucket === 'registered_service') {
      rows.push({
        row_kind: 'registered_service',
        service_key: String(ev.service_key || ev.platform || '')
          .trim()
          .toLowerCase(),
        service_name: String(ev.service_name || ev.platform || 'Service').trim(),
        source: String(ev.source || '').trim(),
        status_label: String(ev.status_label || ev.status || 'confirmed').trim(),
        probe_state: null,
        probe_detail: null,
        probe_method: null,
        target: String(ev.target || '').trim(),
      });
    } else if (bucket === 'native_probe_status') {
      rows.push({
        row_kind: 'native_probe_status',
        service_key: String(ev.service_key || '').trim().toLowerCase(),
        service_name: String(ev.service_name || 'Service').trim(),
        source: 'email_account_checker',
        status_label: String(ev.status_label || ev.probe_state || '').trim(),
        probe_state: String(ev.probe_state || ev.native_status || '').trim(),
        probe_detail: String(ev.probe_detail || '').trim() || null,
        probe_method: String(ev.probe_method || '').trim() || null,
        target: String(ev.target || '').trim(),
      });
    }
  }
  return rows;
}

/**
 * @param {Record<string, unknown>} row
 * @returns {string}
 */
export function probeRowKey(row) {
  return [
    row.row_kind,
    row.service_key,
    row.source || '',
    row.probe_state || '',
    row.probe_detail || '',
  ].join('|');
}

/**
 * @param {string} verdict
 * @returns {string}
 */
export function verdictLabel(verdict) {
  switch (String(verdict || '').toLowerCase()) {
    case 'correct':
      return 'Correct';
    case 'false_positive':
      return 'False positive';
    case 'missed':
      return 'Should be registered';
    default:
      return verdict || '—';
  }
}

/**
 * @param {string} verdict
 * @returns {string}
 */
export function verdictToneClass(verdict) {
  switch (String(verdict || '').toLowerCase()) {
    case 'correct':
      return 'border-emerald-500/40 bg-emerald-950/40 text-emerald-200';
    case 'false_positive':
      return 'border-red-500/40 bg-red-950/40 text-red-200';
    case 'missed':
      return 'border-amber-500/40 bg-amber-950/40 text-amber-200';
    default:
      return 'border-slate-600 bg-slate-800 text-slate-300';
  }
}
